import React from 'react'
import BaseEducationTab from './BaseEducationTab'

export default function BasicEducation() {
  return <BaseEducationTab tabType="basicEducation" />
}
